export var spanishFeminineFields = ["dirección", "ciudad"];
export var spanishMasculineFields = [
    "número de teléfono",
    "código postal",
    "ingreso",
];
